var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.157 4.51c-2.639-1.836-5.897-.98-7.657 1.122-1.76-2.101-5.018-2.968-7.657-1.122-1.4.98-2.279 2.632-2.339 4.376-.14 3.958 3.299 7.13 8.547 11.995l.1.092c.76.704 1.93.704 2.689-.01l.11-.102c5.248-4.855 8.676-8.028 8.546-11.985-.06-1.734-.94-3.387-2.339-4.366ZM12.6 19.361l-.1.102-.1-.102c-4.758-4.396-7.897-7.303-7.897-10.25 0-2.04 1.5-3.57 3.499-3.57 1.54 0 3.039 1.009 3.569 2.406h1.869c.52-1.397 2.02-2.407 3.559-2.407 1.999 0 3.498 1.53 3.498 3.57 0 2.948-3.139 5.855-7.897 10.251Z",
    fill: "#FF5160"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.3d653a26a6325c7478e5f68290e97965.svg";
export { ForwardRef as ReactComponent };